import React, { useState } from 'react';

import { getMessage } from '@shared/utils';
import { formatDateUS } from '@shared/utils/dateUtils';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import type { UseFormRegister } from 'react-hook-form';

import { FieldLabel, useFormFieldSize } from './FormField';

type CustomDateTimeProps = {
  defaultValues: string;
  register: UseFormRegister<any>;
  field: any;
  errors: string;
};

const CustomDateTime = ({ defaultValues = '', register, field, errors = '' }: CustomDateTimeProps) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const size = useFormFieldSize();
  const validators = {
    required: {
      value: !!field?.m,
      message: getMessage('requiredField'),
    },
  };
  const { name, onChange } = register(field?.name, validators);

  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
    onChange({ target: { name, value: date ? formatDateUS(date) : '' }, type: 'change' });
  };

  const resolvedDate = selectedDate ?? (defaultValues ? new Date(defaultValues) : null);
  return (
    <>
      <FieldLabel label={field?.lbl} required={!!field?.m} />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          format="dd/MM/yyyy"
          value={resolvedDate}
          slotProps={{
            textField: {
              name,
              fullWidth: true,
              size,
              error: !!errors,
              helperText: errors,
            },
          }}
          onChange={handleDateChange}
        />
      </LocalizationProvider>
    </>
  );
};

export default CustomDateTime;
